import React, {Component} from "react";
import {
    Table
} from "reactstrap";

import Registry from "../../../Utils/Registry";
import { InvoiceV2Service } from "../../../services";
import EnterpriseInvoicesV2TableLine from "./Table/LineV2";


class EnterpriseInvoicesV2Table extends Component {
    constructor(props) {
        super(props);

        this.api = Registry.registered("api");
        this.user = Registry.observe(this, "user", user => this.user = user);

        this.state = {
            information: false,
            invoices: [],
            allToggle: false
        };
    }

    render() {
        return (
            <div>
                <div className="ty-block">
                    <Table responsive striped hover className="pointer spacing-table marg-b-0 f-12">
                        <thead>
                        <tr className="ty-table-header">
                            <th className="wp-10">N&deg;</th>
                            <th className="wp-10">Date</th>
                            <th className="w-15">Volume</th>
                            <th className="w-15">Prix HT</th>
                            <th className="w-15">Prix TTC</th>
                            <th className="">Pay&eacute;</th>
                            <th className="_w-50"> </th>
                        </tr>
                        </thead>

                        <tbody>
                            {
                                this.props.loading ?
                                    <tr><td colSpan="8" className="center border-0 bg-white"><i className="icon icon-loading animated spin infinite f-20" /></td></tr>
                                    :
                                    this.props.invoices.length ? 
                                        this.props.invoices.map((invoice, i) => {
                                            return (
                                                <EnterpriseInvoicesV2TableLine
                                                    key={i}
                                                    invoice={invoice}
                                                    downloadInvoice={() => InvoiceV2Service.Download(invoice.number)}
                                                />
                                            )
                                        })
                                        :
                                        <tr><td colSpan="8" className="center border-0 bg-white gray_dark">Aucune factures</td></tr>
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
        )
    }
}

EnterpriseInvoicesV2Table.defaultProps = {
    invoices: [],
    loading: false
};

export default EnterpriseInvoicesV2Table;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Invoices/InvoicesV2Table.js